export default __webpack_public_path__ + "./images/ws.6127db11.png";